import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import { DownloadIcon, Employee, Eye, Filter, Active, Office, SearchBig, DeleteDustbin, Tick, Refresh, Reload } from "../AllSvg";
import { formatDate, formatDateTime, formattedDateLong } from "../Date";
import { BASE_URL, IMAGE_URL, TESTING_URL } from "../../config/axios";
import { customSortByKey, downloadAsExcel, formatCurrencyIndian, formatRoundoff2D, handleAllError, handleErrorToast, ViewChatImageorFile, DateRangePicker, CustomImageModal } from "../CustomFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbarcopy";

import { Modal } from "react-bootstrap";
import { DownloadTableExcel } from "react-export-table-to-excel";
import usePermission from "../../config/permissions";
import { CompleteTask, CloseTask, TaskChatboxModal } from "./TasksComponents";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { CSSForDropdownFilter2 } from "../CustomUtilities";

const MyCriticalTasks = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false);
    const [indexRow, setIndexRow] = useState({});
    const [selectedEmpcode, setSelectedEmpcode] = useState(
        `${sessionStorage.getItem("emp_code")}`
    );
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        setShow(true);
        setIndexRow(e);
    };
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [filteredEmployee, setFilteredEmployee] = useState([]);

    const getAllEmployee = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/taskbyemp/${selectedEmpcode}/`
            );
            setAllemployee(res.data);
            setFilteredEmployee(res.data);

            const uniqueDayStatus = [
                ...new Set(res.data.map((entry) => entry.status)),
            ];
            setStatus_list(uniqueDayStatus);
            const uniquePriorityStatus = [
                ...new Set(res.data.map((entry) => entry.priority)),
            ];
            setPriority_status(uniquePriorityStatus);
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAllEmployee();
    }, [selectedEmpcode]);
    // *********** Employee Details Api End ***********

    const today = new Date();
    const today2 = new Date();
    today2.setDate(today2.getDate() + 30);

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const year2 = today2.getFullYear();
    const month2 = today2.getMonth() + 1;
    const day2 = today2.getDate();
    const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    // const [startdate, setStartDate] = useState(`${formattedDatee}`);
    const [startdate, setStartDate] = useState('');
    const formattedDate = `${year2}-${month2.toString().padStart(2, "0")}-${day2
        .toString()
        .padStart(2, "0")}`;
    // const [enddate, setEndDate] = useState(`${formattedDate}`);
    const [enddate, setEndDate] = useState('');
    // console.log(formattedDatee);

    // *********** Filter Logic ***********

    const [selectedDepartment, setSelectedDepartment] = useState("");
    // const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState([
        "pending",
        "inprocess",
        "completed",
    ]);
    const [jobTitle, setJobTitle] = useState("");
    const [status_list, setStatus_list] = useState([]);
    const [asignee, setAsignee] = useState("");
    const [asigning, setAsigning] = useState("");
    const [priority, setPriority] = useState("");
    const [priorityType, setPriorityType] = useState("");
    const [priority_status, setPriority_status] = useState([]);

    function handlePriority(value) {
        if (value == 1) {
            return (
                <button className="priority-button font-weight600 color-tab-red">
                    High
                </button>
            );
        } else if (value == 2) {
            return (
                <button className="priority-button font-weight600 color-tab-yellow">
                    Medium
                </button>
            );
        } else if (value == 3) {
            return (
                <button className="priority-button font-weight600 color-tab-blue">
                    Low
                </button>
            );
        } else return <td className="align-center"></td>;
    }

    const handleSearch = () => {
        // Filter employees based on selected criteria
        let filteredData = allemployee;

        // if (selectedStatus !== '') {
        //     let filteredData = allemployee.filter((employee) => employee === selectedStatus);
        // }
        if (selectedStatus.length > 0) {
            filteredData = filteredData.filter((employee) =>
                selectedStatus.includes(employee.status)
            );
        }
        if (selectedStatus.length === 0) {
            // filteredData = filteredData.filter(employee => selectedStatus.includes(['pending', 'inprocess', 'completed']));
            filteredData = filteredData.filter((employee) =>
                ["pending", "inprocess", "completed"].includes(employee.status)
            );
        }
        // if (selectedStatus !== '') {
        //     filteredData = filteredData.filter(employee => employee.status === selectedStatus);
        // }
        if (asigning !== "") {
            if (asigning == "by") {
                filteredData = filteredData.filter(
                    (employee) =>
                        employee.assignedby === selectedEmpcode
                );
            } else if (asigning == "to") {
                filteredData = filteredData.filter(
                    (employee) =>
                        employee.concern_person === selectedEmpcode
                );
            }
        }
        if (priority !== "") {
            if (priority === "1") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "2") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "3") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            }
        }
        if (asignee) {
            // Use includes for a case-insensitive search for the name only
            const lowercaseSelectedName = asignee.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const nameMatch = employee.assignedbyname
                    .toLowerCase()
                    .includes(lowercaseSelectedName);
                const task = employee.task
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const concernnameMatch = employee.concern_personname
                    .toLowerCase()
                    .includes(lowercaseSelectedName);
                // const empMatch = employee.assignedbyname.toString().includes(asignee);
                const empCodeMatch = employee.assignedby.toString().includes(asignee);
                const empCodeMatchh = employee.concern_person
                    .toString()
                    .includes(asignee);
                // const empMatchh = employee.concern_personname.toString().includes(asignee);

                return (
                    nameMatch || concernnameMatch || empCodeMatch || empCodeMatchh || task
                );
            });
        }

        if (startdate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    (employee.assigndate >= startdate) ||
                    (employee.due_date >= startdate)
            );
        }

        if (enddate !== "") {
            filteredData = filteredData.filter(
                (employee) =>
                    (employee.assigndate <= enddate) ||
                    (employee.due_date <= enddate)
            );
        }

        setFilteredEmployee(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        selectedStatus,
        allemployee,
        asignee,
        startdate,
        enddate,
        asigning,
        priority,
    ]);

    const handlePending = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "inprocess",
                // resume_list_action: false,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const handleAccepted = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "completed",
                // resume_list_action: true,
                complete_date: formattedDate,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const handleCompletedClose = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "close",
                // close_date: formattedDatee,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };
    const handleCompletedReassign = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "pending",
                // resume_list_action: false,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const statusName = [
        {
            status: "pending",
            name: "Pending",
        },
        // {
        //   status: "inprocess",
        //   name: "In process",
        // },
        {
            status: "completed",
            name: "Completed",
        },
        {
            status: "close",
            name: "Close",
        },
    ];

    const options = statusName.map((e) => ({
        value: e.status,
        label: e.name,
    }));

    const handleChangecc = (selected) => {
        const multipleperson =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setSelectedStatus(multipleperson);
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="content-tabs">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div title='Date Range' className="field-cont-div ">
                            <DateRangePicker
                                startDate={startdate}
                                endDate={enddate}
                                placeHolder1="From Date"
                                placeHolder2="To Date"
                                onChange={(start, end) => {
                                    setStartDate(start || '');
                                    setEndDate(end || '');
                                }}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <Select
                                className="attendance-input-field width-15vw"
                                width="200px"
                                options={options}
                                placeholder="Status"
                                isMulti
                                onChange={handleChangecc}
                                styles={CSSForDropdownFilter2}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={asigning}
                                onChange={(e) => setAsigning(e.target.value)}
                            >
                                <option value="null">Assigned</option>
                                <option value="by">By you</option>
                                <option value="to">To you</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <option value="">Priority</option>
                                {priority_status
                                    .sort((a, b) => a - b)
                                    .map((prior) => (
                                        <option value={prior}>
                                            {prior === "1"
                                                ? "High"
                                                : prior === "2"
                                                    ? "Medium"
                                                    : prior === "3"
                                                        ? "Low"
                                                        : "All"}
                                        </option>
                                    ))}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div-svg">
                            <SearchBig />
                            <input
                                className="attendance-input-field width-15vw  "
                                placeholder="By Task, Emp & Name"
                                type="text"
                                value={asignee}
                                onChange={(e) => setAsignee(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn-cont">
                    </div>
                </div>

                <div className="table-css-white-background">
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr no.</th>
                                <th className="align-center">Assign By</th>
                                <th className="align-center">Assigned to</th>
                                <th className="align-center width-15vw">Task</th>
                                <th className="align-center">Assigned Date</th>
                                <th className="align-center">Due date</th>
                                <th className="align-center">Chat History</th>
                                <th className="align-center">Remarks</th>
                                <th className="align-center">Priorty</th>
                                <th className="align-center">Status</th>
                                <th className="align-center">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div> //buffering logic
                        ) : (
                            <tbody>
                                {filteredEmployee
                                    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.assignedbypic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${i.assignedbypic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.assignedbyname, profilepic: i.assignedbypic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>
                                                        {i.assignedby}-{i.assignedbyname}
                                                    </p>
                                                </td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.concern_personpic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${i.concern_personpic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.concern_personname, profilepic: i.concern_personpic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>
                                                        {i.concern_person}-{i.concern_personname}
                                                    </p>
                                                </td>
                                                <td className="align-left width-15vw">
                                                    {" "}
                                                    <div dangerouslySetInnerHTML={createMarkup(i.task)} />
                                                </td>
                                                <td className="align-center">
                                                    {formatDate(i.assigndate)}{" "}
                                                </td>
                                                <td className="align-center">
                                                    {formatDate(i.due_date)}
                                                </td>

                                                <td className="align-center">
                                                    {i.remarks?.map((edata, index) => {
                                                        return (
                                                            <div>
                                                                By : {edata.name}
                                                                <br />
                                                                On: {formatDate(edata.created_at)}
                                                                <br />
                                                                {edata.remark_text}
                                                            </div>
                                                        );
                                                    })}
                                                    <TaskChatboxModal
                                                        i={i}
                                                        getAllTasks={getAllEmployee}
                                                    />
                                                </td>
                                                {/* Remark */}
                                                {show ? (
                                                    <td
                                                        className="align-center"
                                                        onClick={() => handleClose(index + 1)}
                                                    >
                                                        {index + 1 === indexRow ? (
                                                            <Eye color={"#F6F7F9"} bgcolor={"#2576BC"} />
                                                        ) : (
                                                            <Eye color={"#2576BC"} bgcolor={"#F6F7F9"} />
                                                        )}
                                                    </td>
                                                ) : (
                                                    <td
                                                        className="align-center"
                                                        onClick={() => handleShow(index + 1)}
                                                    >
                                                        <Eye color={"#2576BC"} bgcolor={"#F6F7F9"} />
                                                    </td>
                                                )}

                                                <td className="align-center">
                                                    {" "}
                                                    {handlePriority(i.priority)}
                                                </td>
                                                <td className="align-center ">{i.status}</td>
                                                <td className="align-center">
                                                    <div
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        {i.status === "pending" &&
                                                            i.concern_person ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <CompleteTask
                                                                    i={i}
                                                                    getAllTasks={getAllEmployee}
                                                                />
                                                            </>
                                                        ) : i.status === "inprocess" &&
                                                            i.concern_person ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <button
                                                                    title="Complete"
                                                                    className="model-delete-button"
                                                                    onClick={(e) => handleAccepted(e, i.id)}
                                                                >
                                                                    <Tick color={"#F72B50"} />
                                                                </button>
                                                            </>
                                                        ) : i.status === "completed" &&
                                                            i.assignedby ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <button
                                                                    title="Reassign"
                                                                    className="model-edit-button-ml"
                                                                    onClick={(e) =>
                                                                        handleCompletedReassign(e, i.id)
                                                                    }
                                                                >
                                                                    <Reload color={'#145650'} />
                                                                </button>
                                                            </>
                                                        ) : i.status === "close" ? (
                                                            i.assignedby ===
                                                                selectedEmpcode ? (
                                                                <>
                                                                    <button
                                                                        className="model-edit-button-ml"
                                                                        onClick={(e) =>
                                                                            handleCompletedReassign(e, i.id)
                                                                        }
                                                                    >
                                                                        <Reload color={'#145650'} />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                "Closed"
                                                            )
                                                        ) : (
                                                            "waiting..."
                                                        )}
                                                        {(i.status !== "close") &&
                                                            (i.assignedby === selectedEmpcode) && <CloseTask i={i} getAllTasks={getAllEmployee} />
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            {show === true && index + 1 === indexRow ? (
                                                <>
                                                    <tr>
                                                        <td colSpan="1" className="align-center"></td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            Completion:
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.completed_date ? i.completed_date : "No Date"}
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.remark ? i.remark : "No Completion remark"}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1" className="align-center"></td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            Closing:
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.close_date ? `${i.close_date}` : "No Date"}
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.feedback
                                                                ? `${i.feedback}`
                                                                : "No Closing remark"}
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const AssignedCriticalTasks = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [show, setShow] = useState(false);
    const [indexRow, setIndexRow] = useState({});
    const handleClose = () => setShow(false);
    const handleShow = (e) => {
        setShow(true);
        setIndexRow(e);
    };
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [filteredEmployee, setFilteredEmployee] = useState([]);
    const [selectedEmpcode, setSelectedEmpcode] = useState(
        `${sessionStorage.getItem("emp_code")}`
    );

    const getAllEmployee = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/wfm/taskbyemp/${selectedEmpcode}/`);
            setAllemployee(res.data);
            setFilteredEmployee(res.data);

            const uniqueDayStatus = [
                ...new Set(res.data.map((entry) => entry.status)),
            ];
            setStatus_list(uniqueDayStatus);
            const uniquePriorityStatus = [
                ...new Set(res.data.map((entry) => entry.priority)),
            ];
            setPriority_status(uniquePriorityStatus);
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    useEffect(() => {
        getAllEmployee();
    }, [selectedEmpcode]);
    // *********** Employee Details Api End ***********

    const today = new Date();
    const today2 = new Date();
    today2.setDate(today2.getDate() + 30);

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const year2 = today2.getFullYear();
    const month2 = today2.getMonth() + 1;
    const day2 = today2.getDate();
    const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    // const [startdate, setStartDate] = useState(`${formattedDatee}`);
    const [startdate, setStartDate] = useState(``);
    const formattedDate = `${year2}-${month2.toString().padStart(2, "0")}-${day2
        .toString()
        .padStart(2, "0")}`;
    // const [enddate, setEndDate] = useState(`${formattedDate}`);
    const [enddate, setEndDate] = useState(``);
    // console.log(formattedDatee);

    // *********** Filter Logic ***********

    const [selectedDepartment, setSelectedDepartment] = useState("");
    // const [selectedStatus, setSelectedStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState([
        "pending",
        "inprocess",
        "completed",
    ]);
    const [jobTitle, setJobTitle] = useState("");
    const [status_list, setStatus_list] = useState([]);
    const [asignee, setAsignee] = useState("");
    const [asigning, setAsigning] = useState("");
    const [priority, setPriority] = useState("");
    const [priorityType, setPriorityType] = useState("");
    const [priority_status, setPriority_status] = useState([]);

    function handlePriority(value) {
        if (value == 1) {
            return (
                <button className="priority-button font-weight600 color-tab-red">
                    High
                </button>
            );
        } else if (value == 2) {
            return (
                <button className="priority-button font-weight600 color-tab-yellow">
                    Medium
                </button>
            );
        } else if (value == 3) {
            return (
                <button className="priority-button font-weight600 color-tab-blue">
                    Low
                </button>
            );
        } else return <td className="align-center"></td>;
    }

    const handleSearch = () => {
        let filteredData = allemployee;

        // if (selectedStatus !== '') {
        //     let filteredData = allemployee.filter((employee) => employee === selectedStatus);
        // }
        if (selectedStatus.length > 0) {
            filteredData = filteredData.filter((employee) =>
                selectedStatus.includes(employee.status)
            );
        }
        if (selectedStatus.length === 0) {
            // filteredData = filteredData.filter(employee => selectedStatus.includes(['pending', 'inprocess', 'completed']));
            filteredData = filteredData.filter((employee) =>
                ["pending", "inprocess", "completed"].includes(employee.status)
            );
        }
        // if (selectedStatus !== '') {
        //     filteredData = filteredData.filter(employee => employee.status === selectedStatus);
        // }
        if (asigning !== "") {
            if (asigning == "by") {
                filteredData = filteredData.filter(
                    (employee) =>
                        employee.assignedby === selectedEmpcode
                );
            } else if (asigning == "to") {
                filteredData = filteredData.filter(
                    (employee) =>
                        employee.concern_person === selectedEmpcode
                );
            }
        }
        if (priority !== "") {
            if (priority === "1") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "2") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            } else if (priority === "3") {
                filteredData = filteredData.filter(
                    (employee) => employee.priority === priority
                );
            }
        }
        if (asignee) {
            const lowercaseSelectedName = asignee.toLowerCase();
            filteredData = filteredData.filter((employee) => {
                const nameMatch = employee.assignedbyname
                    .toLowerCase()
                    .includes(lowercaseSelectedName);
                const task = employee.task
                    .toLowerCase()
                    .includes(lowercaseSelectedName);

                const concernnameMatch = employee.concern_personname
                    .toLowerCase()
                    .includes(lowercaseSelectedName);
                // const empMatch = employee.assignedbyname.toString().includes(asignee);
                const empCodeMatch = employee.assignedby.toString().includes(asignee);
                const empCodeMatchh = employee.concern_person
                    .toString()
                    .includes(asignee);
                // const empMatchh = employee.concern_personname.toString().includes(asignee);

                return (
                    nameMatch || concernnameMatch || empCodeMatch || empCodeMatchh || task
                );
            });
        }

        if (startdate !== "") {
            // filteredData = filteredData.filter(employee => employee.due_date >= startdate );
            filteredData = filteredData.filter(
                (employee) =>
                    employee.due_date >= startdate && employee.assigndate >= startdate
            );
        }
        if (enddate !== "") {
            // filteredData = filteredData.filter(employee => employee.due_date <= enddate);
            filteredData = filteredData.filter(
                (employee) =>
                    employee.due_date <= enddate && employee.assigndate <= enddate
            );
        }

        setFilteredEmployee(filteredData);
    };

    useEffect(() => {
        handleSearch();
    }, [
        selectedStatus,
        allemployee,
        asignee,
        startdate,
        enddate,
        asigning,
        priority,
    ]);

    const handlePending = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "inprocess",
                // resume_list_action: false,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const handleAccepted = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "completed",
                // resume_list_action: true,
                complete_date: formattedDate,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const handleCompletedClose = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "close",
                // close_date: formattedDatee,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };
    const handleCompletedReassign = async (e, id) => {
        e.preventDefault();
        try {
            let res = await axios.put(`${BASE_URL}/wfm/task/${id}/`, {
                status: "pending",
                // resume_list_action: false,
            });

            if (res.status === 200) {
                await getAllEmployee();
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err)
        }
    };

    const statusName = [
        {
            status: "pending",
            name: "Pending",
        },
        // {
        //   status: "inprocess",
        //   name: "In process",
        // },
        {
            status: "completed",
            name: "Completed",
        },
        {
            status: "close",
            name: "Close",
        },
    ];

    const options = statusName.map((e) => ({
        value: e.status,
        label: e.name,
    }));

    const handleChangecc = (selected) => {
        const multipleperson =
            selected.length > 0 ? selected.map((item) => item.value) : "";
        setSelectedStatus(multipleperson);
    };

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) => {
                return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
            }),
        };
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="content-tabs">
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="From Date"
                                type="date"
                                value={startdate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <input
                                className="attendance-input-field width-10vw   date-field"
                                placeholder="To Date"
                                type="date"
                                value={enddate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <Select
                                className="attendance-input-field width-15vw  "
                                width="200px"
                                options={options}
                                placeholder="Status"
                                isMulti
                                onChange={handleChangecc}
                                styles={CSSForDropdownFilter2}
                            />

                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={asigning}
                                onChange={(e) => setAsigning(e.target.value)}
                            >
                                <option value="null">Assigned</option>
                                <option value="by">By you</option>
                                <option value="to">To you</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={priority}
                                onChange={(e) => setPriority(e.target.value)}
                            >
                                <option value="">Priority</option>
                                {priority_status
                                    .sort((a, b) => a - b)
                                    .map((prior) => (
                                        <option value={prior}>
                                            {prior === "1"
                                                ? "High"
                                                : prior === "2"
                                                    ? "Medium"
                                                    : prior === "3"
                                                        ? "Low"
                                                        : "All"}
                                        </option>
                                    ))}
                                ;
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div-svg">
                            <SearchBig />
                            <input
                                className="attendance-input-field width-15vw  "
                                placeholder="By Task, Emp & Name"
                                type="text"
                                value={asignee}
                                onChange={(e) => setAsignee(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="btn-cont">
                    </div>
                </div>

                <div className="table-css-white-background">
                    <table className="table-css">
                        <thead>
                            <tr className="custom-table-head-tr">
                                <th className="align-left">Sr no.</th>
                                <th className="align-center">Assign By</th>
                                <th className="align-center">Assigned to</th>
                                <th className="align-center width-15vw">Task</th>
                                <th className="align-center">Assigned Date</th>
                                <th className="align-center">Due date</th>
                                <th className="align-center">Chat History</th>
                                <th className="align-center">Remarks</th>
                                <th className="align-center">Priorty</th>
                                <th className="align-center">Status</th>
                                <th className="align-center">Action</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div> //buffering logic
                        ) : (
                            <tbody>
                                {filteredEmployee
                                    .sort((a, b) => new Date(a.due_date) - new Date(b.due_date))
                                    .sort((a, b) => a.priority - b.priority)
                                    .map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.assignedbypic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${i.assignedbypic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.assignedbyname, profilepic: i.assignedbypic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>
                                                        {i.assignedby}-{i.assignedbyname}
                                                    </p>
                                                </td>
                                                <td className="align-center">
                                                    <CustomImageModal customStyle>
                                                        {i.concern_personpic ? (
                                                            <img
                                                                src={`${IMAGE_URL}${i.concern_personpic}`}
                                                                alt="profile" className="profile-img"
                                                            />
                                                        ) : (
                                                            <UserDefaultLogo user={{ name: i.concern_personname, profilepic: i.concern_personpic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                                                        )}
                                                    </CustomImageModal>
                                                    <p>
                                                        {i.concern_person}-{i.concern_personname}
                                                    </p>
                                                </td>
                                                <td className="align-left width-15vw">
                                                    {" "}
                                                    <div dangerouslySetInnerHTML={createMarkup(i.task)} />
                                                </td>
                                                <td className="align-center">
                                                    {formatDate(i.assigndate)}{" "}
                                                </td>
                                                <td className="align-center">
                                                    {formatDate(i.due_date)}
                                                </td>

                                                <td className="align-center">
                                                    {i.remarks?.map((edata, index) => {
                                                        return (
                                                            <div>
                                                                By : {edata.name}
                                                                <br />
                                                                On: {formatDate(edata.created_at)}
                                                                <br />
                                                                {edata.remark_text}
                                                            </div>
                                                        );
                                                    })}
                                                    <TaskChatboxModal
                                                        i={i}
                                                        getAllTasks={getAllEmployee}
                                                    />
                                                </td>
                                                {/* Remark */}
                                                {show ? (
                                                    <td
                                                        className="align-center"
                                                        onClick={() => handleClose(index + 1)}
                                                    >
                                                        {index + 1 === indexRow ? (
                                                            <Eye color={"#F6F7F9"} bgcolor={"#2576BC"} />
                                                        ) : (
                                                            <Eye color={"#2576BC"} bgcolor={"#F6F7F9"} />
                                                        )}
                                                    </td>
                                                ) : (
                                                    <td
                                                        className="align-center"
                                                        onClick={() => handleShow(index + 1)}
                                                    >
                                                        <Eye color={"#2576BC"} bgcolor={"#F6F7F9"} />
                                                    </td>
                                                )}

                                                <td className="align-center">
                                                    {" "}
                                                    {handlePriority(i.priority)}
                                                </td>
                                                <td className="align-center ">{i.status}</td>
                                                <td className="align-center">
                                                    <div
                                                        style={{ display: "flex", alignItems: "center" }}
                                                    >
                                                        {i.status === "pending" &&
                                                            i.concern_person ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <CompleteTask
                                                                    i={i}
                                                                    getAllTasks={getAllEmployee}
                                                                />
                                                            </>
                                                        ) : i.status === "inprocess" &&
                                                            i.concern_person ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <button
                                                                    title="Complete"
                                                                    className="model-delete-button"
                                                                    onClick={(e) => handleAccepted(e, i.id)}
                                                                >
                                                                    <Tick color={"#F72B50"} />
                                                                </button>
                                                            </>
                                                        ) : i.status === "completed" &&
                                                            i.assignedby ===
                                                            selectedEmpcode ? (
                                                            <>
                                                                <button
                                                                    title="Reassign"
                                                                    className="model-edit-button-ml"
                                                                    onClick={(e) =>
                                                                        handleCompletedReassign(e, i.id)
                                                                    }
                                                                >
                                                                    <Reload color={'#145650'} />
                                                                </button>
                                                            </>
                                                        ) : i.status === "close" ? (
                                                            i.assignedby ===
                                                                selectedEmpcode ? (
                                                                <>
                                                                    <button
                                                                        className="model-edit-button-ml"
                                                                        onClick={(e) =>
                                                                            handleCompletedReassign(e, i.id)
                                                                        }
                                                                    >
                                                                        <Reload color={'#145650'} />
                                                                    </button>
                                                                </>
                                                            ) : (
                                                                "Closed"
                                                            )
                                                        ) : (
                                                            "waiting..."
                                                        )}
                                                        {(i.status !== "close") &&
                                                            (i.assignedby === selectedEmpcode) && <CloseTask i={i} getAllTasks={getAllEmployee} />
                                                        }
                                                    </div>
                                                </td>
                                            </tr>
                                            {show === true && index + 1 === indexRow ? (
                                                <>
                                                    <tr>
                                                        <td colSpan="1" className="align-center"></td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            Completion:
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.completed_date ? i.completed_date : "No Date"}
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.remark ? i.remark : "No Completion remark"}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="1" className="align-center"></td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            Closing:
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.close_date ? `${i.close_date}` : "No Date"}
                                                        </td>
                                                        <td
                                                            colSpan="1"
                                                            className="align-center fontsize-bodytext"
                                                        >
                                                            {i.feedback
                                                                ? `${i.feedback}`
                                                                : "No Closing remark"}
                                                        </td>
                                                    </tr>
                                                </>
                                            ) : (
                                                ""
                                            )}
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

export {
    AssignedCriticalTasks,
    MyCriticalTasks,
};